import { render } from "./EditBulkParcelsModal.vue?vue&type=template&id=2b916eb4&ts=true"
import script from "./EditBulkParcelsModal.vue?vue&type=script&lang=ts"
export * from "./EditBulkParcelsModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__